import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=a1f6f28e&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"
import style0 from "./Slider.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./Slider.vue?vue&type=style&index=1&id=a1f6f28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f6f28e",
  null
  
)

export default component.exports